import {
  ACRONYMS as ACRONYMS_SEC,
  GLOSSARY as GLOSSARY_SEC,
  FLASHCARDS as FLASHCARDS_SEC,
  QUESTIONS as QUESTIONS_SEC,
} from "./securityplus";

import {
  ACRONYMS as ACRONYMS_SEC_701,
  GLOSSARY as GLOSSARY_SEC_701,
  FLASHCARDS as FLASHCARDS_SEC_701,
  QUESTIONS as QUESTIONS_SEC_701,
} from "./securityplus701";

export const BUNDLE_ACRONYMS = {
  "SECURITYPLUS701": ACRONYMS_SEC_701,
  "SECURITYPLUS": ACRONYMS_SEC,
}
export const BUNDLE_GLOSSARY = {
  "SECURITYPLUS701": GLOSSARY_SEC_701,
  "SECURITYPLUS": GLOSSARY_SEC,
}
export const BUNDLE_FLASHCARDS = {
  "SECURITYPLUS701": FLASHCARDS_SEC_701,
  "SECURITYPLUS": FLASHCARDS_SEC,
}
export const BUNDLE_QUESTIONS = {
  "SECURITYPLUS701": QUESTIONS_SEC_701,
  "SECURITYPLUS": QUESTIONS_SEC,
}